import React, { useEffect, useMemo, useState } from "react";
import Layout, { PixelStyle } from "../../components/layout";
import { ref, get, push, set, remove } from "firebase/database";
import { MdDone, MdOutlineAdd, MdOutlineClose } from "react-icons/md";
import { database } from "../../config/config";
import TableLayout, { Td, Tr } from "../../components/tableLayout";
import Loader from "../../components/loader";
import { RiDeleteBin6Line } from "react-icons/ri";
import { NavLink } from "react-router-dom";
import { FiEdit3 } from "react-icons/fi";
import { HeaderContainer } from "./viewreport";
import { GoDownload } from "react-icons/go";
import ExportToExcel from "../../components/exportToExcel";
import { Bounce, toast, ToastContainer } from "react-toastify";
import PopUp from "../../components/popUp";
import { useAppContext } from "../../context/appContext";
import { useQuery, useMutation } from "@tanstack/react-query";
import axios from "axios";
import { API_URL } from "../../apis/apiurl";
import { BsCopy } from "react-icons/bs";
import PopupModel from "../../components/model/popupModel";
import { Loader2 } from "lucide-react";
import { fetchUsers } from "../../apis/user";
import { usePagination } from "../../components/Pagination";
import Pagination from "../../components/Pagination";

const TableHead = [
  // "S.N.",
  "User Name & Address",
  "User Role",
  "Report Template",
  "Company Name & Address",
  "access",
  "Action",
];

const Assignreport = () => {
  const { companyList, setPopupMessage } = useAppContext();
  const [users, setUsers] = useState([]);
  const [reportTemplates, setReportTemplates] = useState([]);
  const [accessType, setAccessType] = useState("");
  const [reportUserAccessPermissions, setReportUserAccessPermissions] =
    useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [userId, setUserId] = useState(""); // State variable for selected userId
  const [selectedUserRole, setSelectedUserRole] = useState(""); // State variable for selected userId
  const [reportTemplateId, setReportTemplateId] = useState(""); // State variable for selected reportTemplateId
  const [search, setSearch] = useState("");
  const [loading, setloading] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  // const [popupMessage, setPopupMessage] = useState("");
  // const [ShowPopUp, setShowPopUP] = useState(false);
  // -----------------------------------------------------------------------------------------------------
  const fetchAllReports = async () => {
    const response = await axios.post(
      `${API_URL}/graphql`,
      {
        query: `
      query GetAllAssignReports {
  getAllAssignReports {
    success
    data
  }
}
    `,
      },
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    return response.data.data.getAllAssignReports;
  };

  const fetchTemplates = async () => {
    try {
      const response = await axios.post(
        `${API_URL}/graphql`,
        {
          query: `
          query GetAllTemplates {
            getAllTemplates {
              id
              status
              reportName
              companyId
              createdAt
              updatedAt
              isEditable
              company {
                id
                company
                city
                zipCode
                address
                state
                industry
                clientName
                clientType
                streetAddress
              }
              
            }
          }
        `,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      const templates = response.data.data.getAllTemplates;
      console.log("Fetched templates:", templates); // Debug log
      return templates;
    } catch (error) {
      console.error("Error fetching templates from GraphQL:", error);
      throw error;
    }
  };

  // const fetchUsers = async () => {
  //   const response = await axios.post(
  //     `${API_URL}/graphql`,
  //     {
  //       query: `
  //     query GetAllUsers {
  //       getAllUsers {
  //         id
  //         firstName
  //         lastName
  //         email
  //         phone
  //         role
  //         company
  //         city
  //         state
  //         zipCode
  //         status
  //         streetAddress
  //         address
  //       }
  //     }
  //   `,
  //     },
  //     {
  //       headers: { "Content-Type": "application/json" },
  //     }
  //   );

  //   return response?.data?.data?.getAllUsers;
  // };

  // console.log("searchsearch", search);
  const DeleteAssignReport = async (id) => {
    let data = JSON.stringify({
      query: `mutation DeleteAssignReport { deleteAssignReport(id: ${id}) { success status message } }`,
      variables: {},
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${API_URL}/graphql`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then(async (response) => {
        // console.log(JSON.stringify("123123123123", response.data));
        if (response.data?.data?.deleteAssignReport?.success) {
          await fetchReports();
          toast.success("Deleted successfully");
        } else {
          toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error("Something went wrong");
      });
  };
  const useAssignReport = () => {
    return useMutation({
      mutationKey: ["Create Report"],
      mutationFn: async ({ userId, templateId, accessType }) => {
        try {
          const response = await axios.post(
            `${API_URL}/graphql`,
            {
              query: `
              mutation Mutation($userId: Int, $templateId: Int, $accessType: String) {
                assignReport(userId: $userId, TemplateId: $templateId, accessType: $accessType) {
                 success
        message
                }
              }
            `,
              variables: {
                userId,
                templateId,
                accessType,
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          return response.data;
        } catch (error) {
          console.error("Error assigning report:", error);
          toast.error("Something went wrong");
        }
      },
    });
  };

  const { mutate, isSuccess, error, data } = useAssignReport();
  console.log("companyListcompanyList", companyList);
  useEffect(() => {
    // console.log("123 success", isSuccess);
    // console.log("123 data", data);
    const isSuccessData = data?.data?.assignReport.success;
    const message = data?.data?.assignReport.message;
    if (isSuccessData) {
      fetchReports();
      setUserId("");
      setReportTemplateId("");
      setSearchTemplate("");
      setSearch("");
      setAccessType("");
      // toast

      setPopupMessage(message);
      // setShowPopUP(true);
      // toast.error(message);
      // toast.error(message, {
      //   position: "top-center",
      //   autoClose: 1500,
      //   hideProgressBar: true,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   theme: "light",
      //   transition: Bounce,
      // });
      setloading(false);
    } else {
      setPopupMessage(message);
      setloading(false);

      // setShowPopUP(true);
      // toast.error(message, {
      //   position: "top-center",
      //   autoClose: 1500,
      //   hideProgressBar: true,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   theme: "light",
      //   transition: Bounce,
      // });
    }
  }, [isSuccess]);

  const handleCreateReport = () => {
    console.log("userId reportTemplateId", userId, reportTemplateId);
    if (userId && reportTemplateId) {
      setloading(true);
      mutate({
        userId: JSON.parse(userId),
        templateId: JSON.parse(reportTemplateId),
        accessType,
      });
    }
  };

  // const useTemplates = () => {
  //   return useQuery({ queryKey: ["templates"], queryFn: fetchTemplates });
  // };

  // const useUsers = () => {
  //   return useQuery({ queryKey: ["users"], queryFn: fetchUsers });
  // };
  // const {
  //   data: reportTemplates,
  //   isLoading: templatesLoading,
  //   error: templatesError,
  // } = useTemplates();
  // const {
  //   data: users,
  //   isLoading: usersLoading,
  //   error: usersError,
  // } = useUsers();

  const [reportsList, setReportsList] = useState("");
  const [reportsLoading, setReportsLoading] = useState(true);

  const fetchReports = async () => {
    setReportsLoading(true);
    try {
      const allReportsList = await fetchAllReports();
      setReportsList(allReportsList?.data);
    } catch (error) {
      console.error("Error fetching reports:", error);
      toast.error("Failed to load reports");
    } finally {
      setReportsLoading(false);
    }
  };
  useEffect(() => {
    fetchReports();
    fetchTemplates().then((data) => setReportTemplates(data));
    fetchUsers().then((data) => setUsers(data));
  }, []);

  // console.log("reportsList", reportsList);
  // -----------------------------------------------------------------------------------------------------

  const handleEdit = (permmissionId) => {};

  const [searchQuery, setSearchQuery] = useState("");

  // useEffect

  const [isOpen, setIsOpen] = useState(false);

  const [filteredUsers, setFilteredUsers] = useState();

  // Ensure search is a string and filter users
  // console.log(filteredUsers);
  useEffect(() => {
    if (search) {
      const filter =
        users &&
        users.filter((user) => {
          // Ensure user is an object and not undefined
          if (typeof user !== "object" || user === null) {
            return false;
          }

          // Extract fields safely
          const firstName = user.firstName || "";
          const lastName = user.lastName || "";
          const email = user.email || "";
          const streetAddress = user.streetAddress || "";

          // Check if search starts with firstName, includes lastName, or matches email
          const searchLower = (search || "").toLowerCase();
          const firstNameMatch = firstName
            .toLowerCase()
            .startsWith(searchLower);
          const fullNameMatch =
            `${firstName.toLowerCase()} ${lastName.toLowerCase()}`.includes(
              searchLower
            );
          const emailMatch = email.toLowerCase().includes(searchLower);
          const streetAddressMatch = streetAddress
            .toLowerCase()
            .includes(searchLower);

          // console.log("User:", user);
          // Determine if the user should be included based on search criteria
          return (
            firstNameMatch || fullNameMatch || emailMatch || streetAddressMatch
          );
        });

      setFilteredUsers(filter);
      setIsOpen(true);
    }
  }, [search, users]);

  // console.log("filteredUsersfilteredUsers", filteredUsers);

  // console.log("filteredUsers", filteredUsers);

  const [searchTemplate, setSearchTemplate] = useState("");
  const [showTemplateDropdown, setShowTemplateDropdown] = useState(false);

  const SearchfilteredTemplates =
    reportTemplates &&
    reportTemplates.filter((template) => {
      const reportNameMatch = (template.reportName?.toLowerCase() || "").includes(searchTemplate.toLowerCase());
      const companyMatch = (template.company?.company?.toLowerCase() || "").includes(searchTemplate.toLowerCase());
      return reportNameMatch || companyMatch;
    });

  // Filter templates based on search term

  const combinedData =
    reportsList &&
    reportsList.map((permission) => {
      // Find the user based on userId
      const user = users.find((user) => user.id === permission.userId);

      // Find the report template based on TemplateId (not reportTemplateId as in your data)
      const reportTemplate = reportTemplates.find(
        (temp) => temp.id === permission.TemplateId // Changed to TemplateId to match your data structure
      );

      const company =
        companyList &&
        companyList.find(
          (company) => company.id === permission?.report?.companyId
        );

      // console.log("ppppp", {
      //   permission,
      //   user: permission?.user || null, // Fixed: Use the found user directly
      //   report: permission?.report || null,
      //   company,
      // });
      // Return an object with all the relevant information
      return {
        ...permission,
        user: permission?.user || null, // Fixed: Use the found user directly
        report: permission?.report || null, // Fixed: Use 'report' to match your data structure and ExportPayload expectation
        company,
      };
    });

  const ExportPayload = (data) => {
    if (!data) return [];
    // Ensure data is always an array
    const payload = Array.isArray(data) ? data : [data];

    // Define a mapping from original keys to desired header names
    const headerMapping = {
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      phone: "Phone",
      streetAddress: "Street Address",
      reportTemplateName: "Report Template Name",
      accessType: "Access Type",
      companyLocation: "Company Location",
      companyName: "Company Name",
      userType: "User Type",
    };

    // Map over the payload and clean the data
    const cleanedLeads = payload.map((item) => {
      const { user, report: reportTemplate, company, accessType } = item;

      // Destructure user with fallback values
      const {
        firstName = "",
        lastName = "",
        email = "",
        phone = "",
        streetAddress = "",
        role = "",
      } = user || {};

      // Destructure report template with fallback values
      const { reportName: reportTemplateName = "" } = reportTemplate || {};
      const { company: companyName = "" } = company || {};

      const companyLocation = company?.streetAddress + `,` + company?.state;
      // Create the cleaned object with renamed keys
      const cleanedItem = {
        firstName,
        lastName,
        email,
        phone,
        streetAddress,
        userType: role,
        reportTemplateName,
        companyName,
        companyLocation,
        accessType,
      };

      // Rename keys based on the headerMapping
      const renamedItem = {};
      Object.keys(cleanedItem).forEach((key) => {
        const newKey = headerMapping[key] || key;
        renamedItem[newKey] = cleanedItem[key] ?? "";
      });

      return renamedItem;
    });

    return cleanedLeads;
  };

  const [sortOrder, setSortOrder] = useState(null);
  const [sortField, setSortField] = useState(null);

  const handleSort = (field) => {
    if (sortField === field) {
      if (sortOrder === "asc") {
        setSortOrder("desc");
      } else if (sortOrder === "desc") {
        setSortOrder(null); // Reset to original order on third click
        setSortField(null);
      } else {
        setSortOrder("asc");
      }
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const toggleSortOrder = (header) => {
    const field = headerFieldMapping[header];
    if (field) {
      handleSort(field);
    }
  };

  // Header Field Mapping for Sorting
  const headerFieldMapping = {
    "User Name & Address": "name",
    "User Role": "userType",
    "Report Template": "reportTemplateName",
    "Company Name & Address": "companyLocation",
  };

  const [editReportId, setEditReportId] = useState(null);

  const [editUserId, setEditUserId] = useState(null);

  // State for user search input
  const [userSearchTerm, setUserSearchTerm] = useState("");

  // State for user dropdown visibility
  const [isUserDropdownOpen, setUserDropdownOpen] = useState(false);

  // State for report template search input
  const [templateSearchTerm, setTemplateSearchTerm] = useState("");

  // State for template dropdown visibility
  const [isTemplateDropdownVisible, setTemplateDropdownVisible] =
    useState(false);

  // State for selected access type
  const [selectedAccessType, setSelectedAccessType] = useState("");

  useEffect(() => {
    if (userSearchTerm) {
      const filter = users.filter((user) => {
        // Ensure user is an object and not undefined
        if (typeof user !== "object" || user === null) {
          return false;
        }

        // Extract fields safely
        const firstName = user.firstName || "";
        const lastName = user.lastName || "";
        const email = user.email || "";
        const streetAddress = user.streetAddress || "";

        // Check if search starts with firstName, includes lastName, or matches email
        const searchLower = (userSearchTerm || "").toLowerCase();
        const firstNameMatch = firstName.toLowerCase().startsWith(searchLower);
        const fullNameMatch =
          `${firstName.toLowerCase()} ${lastName.toLowerCase()}`.includes(
            searchLower
          );
        const emailMatch = email.toLowerCase().includes(searchLower);
        const streetAddressMatch = streetAddress
          .toLowerCase()
          .includes(searchLower);

        // console.log("User:", user);
        // Determine if the user should be included based on search criteria
        return (
          firstNameMatch || fullNameMatch || emailMatch || streetAddressMatch
        );
      });

      setFilteredUsers(filter);
      setUserDropdownOpen(true);
    }
  }, [userSearchTerm, users]);

  const filteredTemplates =
    reportTemplates &&
    reportTemplates.filter((template) =>
      template.reportName
        .toLowerCase()
        .includes(templateSearchTerm.toLowerCase())
    );

  const [showReportData, setShowReportData] = useState("");
  // const [editReportTemplateId, setEditReportTemplateId] = useState(null)
  const handleSelect = (templateId, templateName, templateLocation) => {
    setReportTemplateId(templateId);
    if (searchTemplate) {
      setSearchTemplate(templateName); // Update the search input with the selected template name
    }
    if (templateSearchTerm) {
      setTemplateSearchTerm(templateName);
      setShowReportData({
        ...showReportData,
        companyLocation: templateLocation,
      });
    }
    setTemplateDropdownVisible(false);
    setShowTemplateDropdown(false); // Hide the dropdown after selection
  };

  // console.warn("editUserId", editUserId);
  // console.warn("reportTemplateId", reportTemplateId);

  const UpdateCodeHandler = async () => {
    // Move axios import outside the function (should be at top of file)
    try {
      const response = await axios.post(
        `${API_URL}/graphql`,
        {
          query: `
          mutation UpdateAssignReport($updateAssignReportId: ID!, $userId: Int, $templateId: Int, $accessType: String) {
            updateAssignReport(id: $updateAssignReportId, userId: $userId, TemplateId: $templateId, accessType: $accessType) {
              userId
              id
              TemplateId
              accessType
            }
          }
        `,
          variables: {
            updateAssignReportId: editReportId,
            userId: editUserId,
            templateId: reportTemplateId,
            accessType: selectedAccessType,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          maxBodyLength: Infinity,
        }
      );

      console.log("Update successful:", response.data);
      await fetchReports();
      // Reset state after successful update
      setEditReportId(null);
      setEditUserId(null);
      setUserSearchTerm("");
      setTemplateSearchTerm("");
      setSelectedAccessType("");
      setReportTemplateId("");
    } catch (error) {
      console.error("Error updating report:", error);
      // Optionally add error handling UI feedback here
    }
  };

  // Filtering --------------------------------------------------------------

  // Default filters
  const [filters, setFilters] = useState({
    name: "",
    usertype: "", // Changed to "role" to match your data
    reporttemplate: "",
    location: "",
    accessType: "",
  });

  const [filteredReports, setFilteredReports] = useState([]);

  // Pagination
  const {
    currentPage,
    totalPages,
    itemsPerPage,
    totalItems,
    paginatedData,
    handlePageChange,
    handleItemsPerPageChange,
  } = usePagination(filteredReports, 50);

  // console.lo
  // Compute filtered permissions with useMemo to optimize performance
  useEffect(() => {
    const filterAndSortReports = () => {
      if (!reportsList) return [];

      // Step 1: Filter the reports
      let filtered = reportsList.filter((item) => {
        const oneCompany =
          companyList &&
          companyList.find((company) => company.id === item?.report?.companyId);

        return (
          (!filters.name ||
            (item?.user &&
              `${item?.user?.firstName} ${item?.user?.lastName}`
                .toLowerCase()
                .includes(filters.name.toLowerCase()))) &&
          (!filters.usertype ||
            item?.user?.role
              .toLowerCase()
              .includes(filters.usertype.toLowerCase())) &&
          (!filters.reporttemplate ||
            item?.report?.reportName
              ?.toLowerCase()
              ?.includes(filters.reporttemplate.toLowerCase())) &&
          (!filters.location ||
            (oneCompany &&
              (oneCompany.streetAddress
                ?.toLowerCase()
                ?.includes(filters.location.toLowerCase()) ||
                oneCompany.company
                  ?.toLowerCase()
                  ?.includes(filters.location.toLowerCase())))) &&
          (!filters.accessType ||
            item?.accessType
              ?.toLowerCase()
              ?.includes(filters.accessType.toLowerCase()))
        );
      });

      // Step 2: Sort the filtered data if sortField and sortOrder are set
      if (sortField && sortOrder) {
        filtered.sort((a, b) => {
          let valueA, valueB;

          // Map sortField to the correct data field
          switch (sortField) {
            case "name":
              valueA = `${a?.user?.firstName || ""} ${
                a?.user?.lastName || ""
              }`.toLowerCase();
              valueB = `${b?.user?.firstName || ""} ${
                b?.user?.lastName || ""
              }`.toLowerCase();
              break;
            case "userType":
              valueA = a?.user?.role?.toLowerCase() || "";
              valueB = b?.user?.role?.toLowerCase() || "";
              break;
            case "reportTemplateName":
              valueA = a?.report?.reportName?.toLowerCase() || "";
              valueB = b?.report?.reportName?.toLowerCase() || "";
              break;
            case "companyLocation":
              const companyA = companyList.find(
                (c) => c.id === a?.report?.companyId
              );
              const companyB = companyList.find(
                (c) => c.id === b?.report?.companyId
              );
              valueA = companyA?.streetAddress?.toLowerCase() || "";
              valueB = companyB?.streetAddress?.toLowerCase() || "";
              break;
            default:
              return 0;
          }

          // Compare values based on sortOrder
          if (sortOrder === "asc") {
            return valueA.localeCompare(valueB);
          } else {
            return valueB.localeCompare(valueA);
          }
        });
      }

      setFilteredReports(filtered);
    };

    filterAndSortReports();
  }, [reportsList, companyList, filters, sortField, sortOrder]);

  // console.log("filteredReports", filteredReports);
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (userSearchTerm === "") {
      setShowReportData({ ...showReportData, userRole: "" });
    }
    if (templateSearchTerm === "") {
      setShowReportData({ ...showReportData, companyLocation: "" });
    }
  }, [userSearchTerm]);

  // console.log("reportTamplate", reportTemplates);
  // console.log("filteredTemplates", filteredTemplates);

  // const handleDuplicateReport = (reportId) => {
  //   let data = JSON.stringify({
  //     query: `mutation DeplicateAssignReport { deplicateAssignReport(duplicateId: ${reportId}) { success status message data error }}`,
  //     variables: {},
  //   });

  //   let config = {
  //     method: "post",
  //     maxBodyLength: Infinity,
  //     url: `${API_URL}/graphql`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };

  //   axios
  //     .request(config)
  //     .then((response) => {
  //       // console.log("response123", response.data.data.deplicateAssignReport);
  //       const isSuccess = response.data.data.deplicateAssignReport.success;
  //       if (isSuccess) {
  //         fetchReports();
  //         toast("deplicate successfully");
  //       } else {
  //         toast("Something went wrong");
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  return (
    <>
      {/* {
        ShowPopUp && popupMessage && (
          <PopupModel
            message={popupMessage}
            onClose={() => setShowPopUP(false)}
          />
        )
        // <PopUp title={`Report Assignment Already Exist`} />
      } */}

      <div className={`w-full text-sm h-full ${PixelStyle} `}>
        <HeaderContainer pageTitle="assign Report" isRedirecting={false}>
          <span className="text-black">assign report</span>
        </HeaderContainer>

        {/* header to give permissoins */}
        <div className="w-full flex gap-3">
          <div className="w-full flex   justify-between gap-3 lg:gap-10 bg-white shadow p-3 rounded-lg">
            <div className="flex lg:flex-row flex-col lg:items-center  text-sm  gap-3 w-full">
              <div className="flex items-center gap-3 w-full">
                <div className="relative w-full z-20" >
                  <input
                    type="text"
                    placeholder="Search users..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onBlur={() => setTimeout(() => setIsOpen(false), 500)}
                    className="w-full p-2 border rounded shadow-sm outline-none"
                  />
                  {search && isOpen && (
                    <ul className=" absolute p-3 z-10 w-full mt-1 border border-gray-300 rounded bg-white shadow-lg max-h-52 overflow-y-auto assignReportScroll">
                      {filteredUsers && filteredUsers.length > 0 ? (
                        filteredUsers.map((user, index) => (
                          <li
                            key={index}
                            className="p-2 border-b hover:bg-gray-200 cursor-pointer flex items-center gap-3"
                            onClick={() => {
                              setSearch(
                                user?.firstName +
                                  " " +
                                  user?.lastName +
                                  " (" +
                                  user?.email +
                                  ")" || ""
                              ); // Ensure user has firstName
                              setIsOpen(false);
                              setUserId(user.id);
                              setSelectedUserRole(user?.role);
                            }}
                          >
                            <div className="font-semibold bg-zinc-800 text-white w-10 h-10 flex items-center justify-center rounded-full">
                              {user.firstName ? user.firstName[0] : "?"}
                              {user.lastName ? user.lastName[0] : "?"}
                            </div>
                            <div className="flex flex-col">
                              <span className="text-blue-600 text-base">
                                {user?.firstName + " " + user?.lastName}
                              </span>
                              <span className="text-zinc-400 ">
                                {user?.streetAddress}
                              </span>
                            </div>
                          </li>
                        ))
                      ) : (
                        <li className="p-2 text-gray-500">No users found</li>
                      )}
                    </ul>
                  )}
                </div>

                <div className="relative w-full z-20">
                  <input
                    type="text"
                    placeholder="Search Report Template"
                    className="w-full p-2 border rounded shadow-sm outline-none"
                    value={searchTemplate}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSearchTemplate(value);
                      if (value) {
                        setShowTemplateDropdown(true);
                      } else {
                        setShowTemplateDropdown(false);
                      }
                    }}
                  />
                  {showTemplateDropdown && (
                    <ul className="absolute p-3 z-10 w-full mt-1 border border-gray-300 rounded bg-white shadow-lg max-h-52 overflow-y-auto assignReportScroll">
                      {SearchfilteredTemplates &&
                      SearchfilteredTemplates.length > 0 ? (
                        SearchfilteredTemplates.map(
                          (template) =>
                            template.reportName && (
                              <li
                                key={template.id}
                                className="p-2 border-b hover:bg-gray-200 cursor-pointer flex items-center gap-3"
                                onClick={() =>
                                  handleSelect(template.id, template.reportName)
                                }
                              >
                                <div className="flex flex-col">
                                  <span className=" text-base font-semibold">
                                    {template.reportName && template.reportName}
                                  </span>
                                  <span className=" flex ">
                                    <span className="">
                                      {template?.company?.clientName}
                                    </span>
                                  </span>
                                  <span className="text-zinc-400 ">
                                    {`${template.company?.address}, ${template.company?.city}, 
                                    ${template.company?.state} ${template.company?.zipCode}`}
                                    {/* {template.company?.streetAddress &&
                                      template.company?.streetAddress +
                                        `,` +
                                        template.company?.state} */}
                                  </span>
                                </div>
                              </li>
                            )
                        )
                      ) : (
                        <li className="p-2 text-gray-500">
                          No templates found
                        </li>
                      )}
                    </ul>
                  )}
                </div>

                <select
                  className="py-2 border rounded-md px-2 capitalize w-full"
                  value={accessType}
                  onChange={(e) => setAccessType(e.target.value)}
                >
                  <option value="">Select Access Type</option>
                  {selectedUserRole && selectedUserRole === "security" && (
                    <option value="populateLimitedAccess">
                      Populate - Limited Access
                    </option>
                  )}
                  {selectedUserRole && selectedUserRole === "security" && (
                    <option value="populateFullAccess">
                      Populate - Full Access
                    </option>
                  )}
                  {selectedUserRole && selectedUserRole !== "security" && (
                    <option value="viewLiveFullAccess">
                      View - Live - Full Access
                    </option>
                  )}
                  {selectedUserRole && selectedUserRole !== "security" && (
                    <option value="viewLiveLimitedAccess">
                      View - Live - Limited Access
                    </option>
                  )}
                  {selectedUserRole && selectedUserRole !== "security" && (
                    <option value="viewSubmittedFullAccess">
                      View - Submitted - Full Access
                    </option>
                  )}
                  {selectedUserRole && selectedUserRole !== "security" && (
                    <option value="viewSubmittedLimitedAccess">
                      View - Submitted - Limited Access
                    </option>
                  )}
                </select>
              </div>
              <div className="flex justify-end  xl:hidden ">
                <AddPermissonButtton
                  onClick={handleCreateReport}
                  loading={loading}
                />
              </div>
            </div>
          </div>
          <div className="hidden xl:flex  items-center gap-2">
            <AddPermissonButtton
              onClick={handleCreateReport}
              loading={loading}
            />
          </div>
        </div>

        {/* {errorMessage && <p className='text-danger'>{errorMessage}</p>} */}

        {/* <div className='bg-white  p-3 rounded-lg shadow mt-3 flex flex-col gap-5 w-full'> */}
        <div className="flex justify-between items-center w-full px-5 mt-3">
            <h4 className="text-sm font-semibold">Permissions</h4>

            <button
              className="text-zinc-500 p-2 rounded flex items-center gap-2"
              onClick={() =>
                ExportToExcel(ExportPayload(combinedData), "Assign report")
              }
            >
              <GoDownload className="text-xl" />
            </button>
          </div>
        <div className="bg-white rounded-2xl shadow-lg overflow-auto">
          {reportsLoading ? (
            <div className="flex justify-center items-center py-32">
              <Loader />
            </div>
          ) : (
            <TableLayout
              TableHead={TableHead}
              sortField={sortField}
              sortOrder={sortOrder}
              toggleSortOrder={toggleSortOrder}
              headerFieldMapping={headerFieldMapping}
              showPagination={false}
            >
              <>
                {/* Filters */}
                <tr className="border-b bg-zinc-50 text-xs  ">
                {["Name", "userType", "Report Template", "Location"].map(
                  (header, index) => (
                    <th scope="col" className="px-6 py-1 " key={index}>
                      <input
                        placeholder={`Filter by ${
                          header === "userType"
                            ? "User Role"
                            : header === "Location"
                            ? "Company & Address"
                            : header
                        }`}
                        name={header.toLowerCase().replace(" ", "")}
                        value={filters[header.toLowerCase().replace(" ", "")]}
                        onChange={handleFilterChange}
                        className="border p-1 px-2 rounded-md font-normal outline-blue-500"
                      />
                    </th>
                  )
                )}

                <th className="px-6 py-1 ">
                  <input
                    name="accessType"
                    value={filters?.accessType}
                    onChange={handleFilterChange}
                    className="border p-1 px-2 rounded-md font-normal outline-blue-500"
                    placeHolder="Select Access Type"
                  />
                  {/* <select name="accessType" onChange={handleFilterChange}  className='border p-1 px-2 rounded-md font-normal outline-blue-500' >
                  <option value=''>Select Access Type</option>
                  <option value='Populate'>Populate</option>
                  <option value='View-Limited'>View-Limited</option>
                  <option value='View-Full'>View-Full</option>
                  <option value='Edit'>Edit</option>
                  </select> */}
                </th>
                <th className="px-6 py-1 "></th>
              </tr>
              {paginatedData &&
                paginatedData.map((permission, index) => {
                  const COMPANY =
                    companyList &&
                    companyList.find(
                      (company) => company.id === permission?.report?.companyId
                    );
                  return (
                    <>
                      <Tr
                        key={index}
                        className={`${
                          editReportId === permission.id &&
                          " bg-gray-100 hover:bg-gray-100"
                        }`}
                      >
                        <Td>
                          <b>
                            {permission?.user?.firstName}{" "}
                            {permission?.user?.lastName}
                          </b>
                          <br />
                          {/* {permission?.user?.streetAddress}{" "}
                          {permission?.user?.city} */}

                          {`${permission?.user?.address}, ${permission?.user?.city}, 
                                            ${permission?.user?.state} ${permission?.user?.zipCode}`}
                          <br />
                          <span className="text-secondary">
                            {permission?.user?.email}
                          </span>
                        </Td>
                        <Td className="capitalize">{permission?.user?.role}</Td>
                        <Td>{permission?.report?.reportName}</Td>
                        <Td>
                          <b>{COMPANY?.company}</b>
                          <br />
                          {`${COMPANY?.address}, ${COMPANY?.city}, 
                                            ${COMPANY?.state} ${COMPANY?.zipCode}`}
                        </Td>
                        <Td>
                          {accessTypeMap[permission.accessType] ||
                            permission.accessType}
                        </Td>

                        <Td>
                          <div className="text-sm flex gap-1">
                            {/* <button
                              className="hover:text-blue-500 hover:bg-blue-100 p-1.5 rounded-lg"
                              onClick={() =>
                                handleDuplicateReport(permission?.id)
                              }
                            >
                              <BsCopy />
                            </button> */}

                            <button
                              className="hover:text-blue-500 hover:bg-blue-100 p-1.5 rounded-lg"
                              onClick={() => {
                                setEditReportId(permission.id);
                                setEditUserId(permission.userId);
                                setReportTemplateId(
                                  permission.reportTemplateId
                                );
                              }}
                            >
                              <FiEdit3 />
                            </button>

                            <button
                              className="hover:text-red-500 hover:bg-red-100 p-1.5 rounded-lg"
                              onClick={() => DeleteAssignReport(permission.id)}
                            >
                              <RiDeleteBin6Line />
                            </button>
                          </div>
                        </Td>
                      </Tr>
                      {editReportId === permission.id && (
                        <tr className="h-30 w-full bg-gray-300 text-sm">
                          <td className="py-3 relative pl-3">
                            <input
                              type="text"
                              placeholder="Search users..."
                              value={userSearchTerm}
                              onChange={(e) =>
                                setUserSearchTerm(e.target.value)
                              }
                              onBlur={() =>
                                setTimeout(
                                  () => setUserDropdownOpen(false),
                                  200
                                )
                              }
                              className="w-full p-2 border rounded shadow-sm outline-none"
                            />
                            {userSearchTerm && isUserDropdownOpen && (
                              <ul className="absolute z-50 p-3 w-full mt-1 border border-gray-300 rounded bg-white shadow-lg max-h-52 overflow-y-auto assignReportScroll">
                                {filteredUsers.length > 0 ? (
                                  filteredUsers.map((user, index) => (
                                    <li
                                      key={index}
                                      className="p-2 border-b hover:bg-gray-200 cursor-pointer flex items-center gap-3"
                                      onClick={() => {
                                        setUserSearchTerm(
                                          user?.firstName +
                                            " " +
                                            user?.lastName +
                                            " (" +
                                            user?.email +
                                            ")" || ""
                                        );
                                        setShowReportData({
                                          ...showReportData,
                                          userRole: user.type,
                                        });
                                        setUserDropdownOpen(false);
                                        setEditUserId(user.id);
                                        // setSelectedUserRole(user);
                                      }}
                                    >
                                      <div className="font-semibold bg-zinc-800 text-white w-10 h-10 flex items-center justify-center rounded-full">
                                        {user.firstName
                                          ? user.firstName[0]
                                          : "?"}
                                        {user.lastName ? user.lastName[0] : "?"}
                                      </div>
                                      <div className="flex flex-col">
                                        <span className="text-blue-600 text-base">
                                          {user?.firstName +
                                            " " +
                                            user?.lastName}
                                        </span>
                                        <span className="text-zinc-400">
                                          {user?.streetAddress}
                                        </span>
                                      </div>
                                    </li>
                                  ))
                                ) : (
                                  <li className="p-2 text-gray-500">
                                    No users found
                                  </li>
                                )}
                              </ul>
                            )}
                          </td>
                          <td className="px-6 py-1 text-zinc-800 text-sm">
                            {userSearchTerm && showReportData?.userRole}
                          </td>
                          <td className="py-3 relative">
                            <input
                              type="text"
                              placeholder="Search Report Template"
                              className="w-full p-2 border rounded shadow-sm outline-none"
                              value={templateSearchTerm}
                              onChange={(e) => {
                                const value = e.target.value;
                                setTemplateSearchTerm(value);
                                if (value) {
                                  setTemplateDropdownVisible(true);
                                } else {
                                  setTemplateDropdownVisible(false);
                                }
                              }}
                            />
                            {templateSearchTerm &&
                              isTemplateDropdownVisible && (
                                <ul className="absolute p-3 z-50 w-full mt-1 border border-gray-300 rounded bg-white shadow-lg max-h-52 overflow-y-auto assignReportScroll">
                                  {filteredTemplates.length > 0 ? (
                                    filteredTemplates.map((template) => (
                                      <li
                                        key={template?.id}
                                        className="p-2 border-b hover:bg-gray-200 cursor-pointer flex items-center gap-3"
                                        onClick={() =>
                                          handleSelect(
                                            template?.id,
                                            template?.reportName,
                                            template?.companyLocation
                                          )
                                        }
                                      >
                                        <span className="flex flex-col">
                                          <p className="text-md">
                                            {template?.reportName}
                                          </p>
                                          <p className="font-semibold">
                                            {template?.company?.company}
                                          </p>
                                          <p className="text-zinc-500">
                                            {`${template?.company?.address}, ${template?.company?.city}, 
                                            ${template?.company?.state} ${template?.company?.zipCode}`}
                                          </p>
                                        </span>
                                      </li>
                                    ))
                                  ) : (
                                    <li className="p-2 text-gray-500">
                                      No templates found
                                    </li>
                                  )}
                                </ul>
                              )}
                          </td>
                          <td className="px-6 py-1 text-sm">
                            {templateSearchTerm &&
                              showReportData?.companyLocation}
                          </td>

                          <td className="text-sm">
                            <select
                              className="py-2 border rounded-md px-2 capitalize w-full"
                              value={selectedAccessType}
                              onChange={(e) =>
                                setSelectedAccessType(e.target.value)
                              }
                            >
                              <option value="">Select Access Type</option>
                              {permission?.user?.role &&
                                permission?.user?.role === "security" && (
                                  <option value="populateLimitedAccess">
                                    Populate - Limited Access
                                  </option>
                                )}
                              {permission?.user?.role &&
                                permission?.user?.role === "security" && (
                                  <option value="populateFullAccess">
                                    Populate - Full Access
                                  </option>
                                )}
                              {permission?.user?.role &&
                                permission?.user?.role !== "security" && (
                                  <option value="viewLiveFullAccess">
                                    View - Live - Full Access
                                  </option>
                                )}
                              {permission?.user?.role &&
                                permission?.user?.role !== "security" && (
                                  <option value="viewLiveLimitedAccess">
                                    View - Live - Limited Access
                                  </option>
                                )}
                              {permission?.user?.role &&
                                permission?.user?.role !== "security" && (
                                  <option value="viewSubmittedFullAccess">
                                    View - Submitted - Full Access
                                  </option>
                                )}
                              {permission?.user?.role &&
                                permission?.user?.role !== "security" && (
                                  <option value="viewSubmittedLimitedAccess">
                                    View - Submitted - Limited Access
                                  </option>
                                )}
                            </select>
                          </td>
                          <td className="text-sm">
                            <div className="flex justify-end pr-2">
                              <div className="flex gap-2 items-center">
                                <button
                                  className="text-sm bg-white hover:bg-red-100 text-red-600 border hover:border-red-500 p-2 px-3  rounded-md"
                                  onClick={() => {
                                    setEditReportId(null);

                                    setEditUserId(null);
                                    setUserSearchTerm("");
                                    setTemplateSearchTerm("");
                                    setSelectedAccessType("");
                                    setReportTemplateId("");
                                  }}
                                >
                                  <MdOutlineClose />
                                </button>
                                <button
                                  className="text-sm bg-white hover:bg-green-100 text-green-600 border hover:border-green-500 p-2 px-3 rounded-md"
                                  onClick={UpdateCodeHandler}
                                >
                                  <MdDone />
                                </button>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </>
                  );
                })}
            </>
          </TableLayout>
          )}

          {/* <div className='py-32 '></div> */}
          {/* {!reportUserAccessPermissions.length > 0 && (
            <div className="flex justify-center items-center py-32">
            
              No report user access permissions found
            </div>
          )} */}
        </div>

        {/* Pagination - Outside shadow card */}
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          itemsPerPage={itemsPerPage}
          totalItems={totalItems}
          onItemsPerPageChange={handleItemsPerPageChange}
          className="mt-4"
        />

        <div className="py-32"></div>
      </div>
      {/* <ToastContainer /> */}
    </>
  );
};

export default Assignreport;

const AddPermissonButtton = ({ onClick, type, title, loading }) => (
  <div className="bg-white xl:shadow lg:p-3 pt-2 rounded-lg text-nowrap flex items-center">
    <button
      className={` p-2 px-5 rounded-md  ${
        type === "cancel"
          ? "hover:bg-red-500 border hover:text-white"
          : "bg-blue-500 text-white"
      } `}
      onClick={onClick}
    >
      {type === "cancel" ? (
        "cancel"
      ) : loading ? (
        <Loader2 className="animate-spin" size={20} />
      ) : (
        "Add Permission"
      )}
    </button>
  </div>
);



const accessTypeMap = {
  populateLimitedAccess: "Populate Limited Access",
  populateFullAccess: "Populate - Full Access",

  viewLiveFullAccess: "View - Live - Full Access",
  viewLiveLimitedAccess: "View - Live - Limited Access",

  viewSubmittedFullAccess: "View - Submitted - Full Access",
  viewSubmittedLimitedAccess: "View - Submitted - Limited Access",
};